module.exports = __webpack_public_path__ + "static/img/weather_013.76595d1e.svg";